import * as React from 'react';
import './adminBadge.css';

/* eslint-disable react/no-unescaped-entities */
export default function AdminBadge({ isAdmin }: any): JSX.Element {
  return <>{isAdmin && <div className="adminBadge">管理者モード</div>}</>;
}
